<template>
    <div id="lt-yantr" class="calc-section debt-payoff yantr-tracking">
        <div class="row">
            <div :class="filterWidth">
                <div class="calc-panel">
                    <div class="row">
                        <div class="col-xs-12">
                            <h5 class="form-header">Your current loans:</h5>
                        </div>
                    </div>
                    <div class="mobile-form visible-xs">
                        <div class="row">
                            <div class="col-xs-5">
                                <lt-label :label="loanTypeLabel" />
                            </div>
                            <div class="col-xs-7">
                                <lt-label :label="loanBalanceLabel" />
                            </div>
                        </div>
                        <div v-for="(item, index) in ElementList" :key="index" :todo="item">
                            <div class="row">
                                <div class="col-xs-5 loantypelist">
                                    <select v-model="item.loanType" @change="onLoanTypeChange(index, item.loanType)">
                                        <option v-for="(option, innerIndex) in LoanTypeList" :key="innerIndex" :value="option.value">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-xs-5 loantypelist">
                                    <number-input :id="appendIndex('loanBalance', index)" v-model="item.loanBalance" inputmode="decimal" @input="onLoanBalanceChange(item.loanType)" />
                                </div>
                                <div class="col-xs-2 text-center add-less-wrapper">
                                    <a v-show="index==ElementList.length-1" href="javascript:void(0)" @click="addNewLoanDetail">
                                        <i class="lt-icons lt4-PlusCircle"></i>
                                    </a>
                                    <a v-show="index<ElementList.length-1" href="javascript:void(0)" @click="removeLoanDetail(index);">
                                        <i class="lt-icons lt4-MinusCircle"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div v-show="ShowError" class="form-group">
                            <span class="text-danger">Please select loan type and enter non zero loan balance.</span>
                        </div>
                        <div class="row">
                            <div class="col-xs-5 total-label">
                                <div class="form-group">
                                    <span>Total:</span>
                                </div>
                            </div>
                            <div class="col-xs-7 total-label">
                                <div class="form-group">
                                    <span>{{ totalLoanAmount | formatMoney }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="desktop-form hidden-xs">
                        <ul>
                            <li>
                                <div v-for="(item, index) in potentialSavingDetails" :key="index" :todo="item" class="col-sm-12 current-loans-list">
                                    <a v-show="index<ElementList.length" href="javascript:void(0)" @click="removeLoanDetail(index);">
                                        <i class="lt-icons lt4-MinusCircle"></i>
                                    </a>
                                    <div class="current-loans">
                                        <span>{{ item.loanTypeFormated }}</span>
                                        <span>{{ item.loanBalance | formatMoney }}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="add-loan-section">
                            <a href="javascript:void(0)" @click="showModal = true">
                                <i class="lt-icons lt4-PlusCircle"></i>
                            </a>
                            <span>Add a Loan</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <a href="#calculate-amount-section" class="btn btn-blue btn-block calculate-saving visible-xs" @click="showTableAndTrackEvent('debtReliefSimpleCalcCalculateSavingsCTA')">Calculate Savings</a>
                            <a href="javascript:void(0)" class="btn btn-blue btn-block calculate-saving hidden-xs" @click="showTableAndTrackEvent('debtReliefSimpleCalcCalculateSavingsCTA')">Calculate Savings</a>
                            <modal v-if="showModal" @close="closeModal">
                                <div slot="body">
                                    <h3>Add a loan</h3>
                                    <lt-label label="Loan type:" />
                                    <drop-down v-model="LoanType" :options="LoanTypeList" />
                                    <lt-label label="Loan amount:" />
                                    <number-input v-model="LoanBalance" />
                                    <div v-show="ShowError" class="form-group">
                                        <span class="text-danger">Please enter non zero loan amount. </span>
                                    </div>
                                    <div class="text-right">
                                        <button class="modal-default-button btn btn-blue" @click="addModalValue">
                                            Add Loan
                                        </button>
                                    </div>
                                </div>
                            </modal>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="outputWidth">
                <div id="calculate-amount-section" class="calculate-amount-section">
                    <div class="saving-table">
                        <table class="table total-saving-display">
                            <thead>
                                <tr>
                                    <th width="33%" class="text-center visible-xs">Total Debt</th>
                                    <th class="text-center hidden-xs">Total Debt to Pay</th>
                                    <th width="33%" class="text-center">Total Savings</th>
                                    <th width="33%" class="text-center">Debt Free</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center">{{ totalLoanBalance | formatMoney }}</td>
                                    <td class="text-green text-center">{{ (totalLoanBalance * 0.3 / 1000) | formatMoney }}k - {{ (totalLoanBalance * 0.4 / 1000) | formatMoney }}k</td>
                                    <td class="text-green text-center">{{ totalLoanBalance | formatDebtFreeDate }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id="graph-chart" class="hideData">
                        <img src="./images/graph.png" />
                        <div class="row">
                            <div class="col-xs-4">
                                <label>Today</label>
                            </div>
                            <div class="col-xs-4 text-right">
                                <label class="graph-label">{{ totalEstimatedReduction }} Mo</label>
                            </div>
                            <div class="col-xs-4 text-right">
                                <label>10 - 20 Yrs</label>
                            </div>
                        </div>
                    </div>
                    <div class="hidden-xs calc-filter compare-debt-relief-provider text-center">
                        <div>
                            <h4 class="hidden-xs">Get on the road to eliminating debt!</h4>
                        </div>
                        <button class="btn btn-orange btn-arrow" type="submit" @click="redirect('_blank')">{{ DestinationButtonText }}</button>
                    </div>
                    <div id="potential-saving-detail" class="saving-table loans-listing-table hideData">
                        <lt-label label="Potential Savings:" class="potential-saving-heading" />
                        <table class="table table-striped">
                            <thead class="hidden-xs">
                                <tr>
                                    <th>Loan Type</th>
                                    <th class="text-left">Amount</th>
                                    <th class="text-left">Savings</th>
                                    <th class="text-right">Est. Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in potentialSavingDetails" :key="index" :todo="item" class="elementlist">
                                    <td>{{ item.loanTypeFormated }}</td>
                                    <td class="hidden-xs text-left">{{ item.loanBalanceUnformated | formatMoney }}</td>
                                    <td class="visible-xs text-right">{{ (item.loanBalanceUnformated * 0.3) | formatMoney }} - {{ unformatFigure(item.loanBalanceUnformated) * 0.4 | formatMoney }}</td>
                                    <td class="hidden-xs text-left">{{ (item.loanBalanceUnformated * 0.3) | formatMoney }} - {{ (item.loanBalanceUnformated * 0.4) | formatMoney }}</td>
                                    <td class="hidden-xs text-right">{{ item.loanBalanceUnformated | formatDebtFreeDate }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="hidden-lg hidden-md hidden-sm calc-filter compare-debt-relief-provider text-center">
                        <button class="btn btn-orange btn-block" type="submit" @click="redirect('_blank')">{{ DestinationButtonText }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import LtLabel from '~/components/lt-label.vue';
    import NumberInput from '~/components/number-input.vue';
    import BaseMixin from '~/mixin/base-mixin';
    import LoanTypesList from '~/constants/loan-type-list';
    import DropDown from '~/components/drop-down.vue';
    import Redirection from '~/mixin/redirection';
    import SessionIdHelper from '~/helpers/uuid-service';
    import InteractionTracking from '~/mixin/interaction-tracking';
    import FormatDebtFreeDateFilter from './filters/debt-free-date-filter';
    import FormatMoneyFilter from './filters/money-filter';
    import Modal from '~/components/modal.vue';

    export default {
        props: {
            loanTypeLabel: {
                type: String,
                default: 'Loan Type',
            },
            loanBalanceLabel: {
                type: String,
                default: 'Loan Balance',
            },
            defaultLoanBalance: {
                default: 0,
            },
            destinationLinkOrId: {
                default: 'ns-pp-cl',
            },
            destinationAmount: {
                default: '&debt=',
            },
            destinationButtonText: {
                default: 'Compare Debt Relief Providers',
            },
            filterWidth: {
                default: 'col-xs-12 col-sm-5 col-md-4 col-lg-4',
            },
            outputWidth: {
                default: 'col-xs-12 col-sm-7 col-md-8 col-lg-8',
            },
            defaultLoanType: {
                type: String,
                default: 'Credit Card',
            },
            isCalculateButtonClicked: {
                type: Boolean,
                default: false,
            },
            loanBalanceId: {
                type: String,
                default: 'loanBalance',
            },
        },
        data() {
            return {
                DestinationLinkOrId: this.destinationLinkOrId + this.destinationAmount,
                DestinationButtonText: this.destinationButtonText,
                LoanTypeList: LoanTypesList.DebtPayoffLoanTypeList,
                ElementList: [{
                    loanType: this.defaultLoanType, loanBalance: this.defaultLoanBalance, loanTypeFormated: this.defaultLoanType, loanBalanceUnformated: this.defaultLoanBalance,
                }],
                SessionId: SessionIdHelper.getSession(),
                showModal: false,
                ShowError: false,
                LoanType: this.defaultLoanType,
                LoanBalance: this.defaultLoanBalance,
                IsCalculateButtonClicked: this.isCalculateButtonClicked,
            };
        },
        methods: {
            removeLoanDetail(index) {
                this.ElementList.splice(index, 1);
                for (let i = 0; i < this.ElementList.length; i++) {
                    if (this.ElementList[i].loanBalance > 0) {
                        this.ElementList[i].loanBalance = Accounting.formatMoney(this.ElementList[i].loanBalance, { symbol: '', precision: 0 });
                    }
                }
            },
            addNewLoanDetail() {
                if (this.ElementList.length > 0 && this.ElementList[this.ElementList.length - 1].loanType !== '' && this.ElementList[this.ElementList.length - 1].loanBalanceUnformated > 0) {
                    this.ShowError = false;
                    this.ElementList.push({
                        loanType: this.LoanType, loanBalance: this.LoanBalance, loanTypeFormated: '', loanBalanceUnformated: 0,
                    });
                } else {
                    this.ShowError = true;
                }
            },
            trackButtonClickEvent(eventName) {
                const loanTypes = [];
                for (let i = 0; i < this.ElementList.length; i++) {
                    if (this.ElementList[i].loanType !== '') loanTypes.push(this.ElementList[i].loanTypeFormated);
                }
                if (this.totalLoanBalance > 0 && this.ElementList.length > 0) {
                    if (window.ltanalytics) {
                        window.ltanalytics.track(eventName, {
                            sid: this.SessionId,
                            debtAmount: this.totalLoanBalance,
                            LoanTypes: loanTypes.toString(),
                        });
                    }
                }
            },
            showTableAndTrackEvent(eventName) {
                this.IsCalculateButtonClicked = true;
                if (this.totalLoanBalance > 0 && this.ElementList.length > 0) {
                    document.getElementById('graph-chart').classList.remove('hideData');
                    document.getElementById('potential-saving-detail').classList.remove('hideData');
                    this.trackButtonClickEvent(eventName);
                }
            },
            addModalValue() {
                if (this.LoanType !== '' && this.LoanBalance > 0) {
                    this.ShowError = false;
                    this.ElementList[this.ElementList.length - 1].loanType = this.LoanType;
                    this.ElementList[this.ElementList.length - 1].loanBalance = this.LoanBalance;
                    this.showModal = false;
                    this.changeSelect(this.LoanType);
                    this.LoanType = this.defaultLoanType;
                    this.LoanBalance = 0;
                    this.ElementList.push({
                        loanType: this.LoanType, loanBalance: this.LoanBalance, loanTypeFormated: '', loanBalanceUnformated: 0,
                    });
                } else {
                    this.ShowError = true;
                }
            },
            closeModal() {
                this.showModal = false;
                this.LoanType = this.defaultLoanType;
                this.LoanBalance = 0;
                this.ShowError = false;
            },
            changeSelect(value) {
                let counter = 0;
                for (let i = 0; i < this.ElementList.length; i++) {
                    if (value === this.ElementList[i].loanType && Accounting.unformat(this.ElementList[i].loanBalance) > 0) counter++;
                }
                let secondCounter = counter;
                if (counter > 0) {
                    for (let i = 0; i < this.ElementList.length; i++) {
                        if (value === this.ElementList[i].loanType && Accounting.unformat(this.ElementList[i].loanBalance) > 0) {
                            this.ElementList[i].loanBalanceUnformated = Accounting.unformat(this.ElementList[i].loanBalance);
                            if (counter > 1) {
                                this.ElementList[i].loanTypeFormated = `${this.ElementList[i].loanType} #${counter - (secondCounter - 1)}`;
                                secondCounter--;
                            } else {
                                this.ElementList[i].loanTypeFormated = this.ElementList[i].loanType;
                            }
                        }
                    }
                }
                if (this.ElementList.length > 0 && this.ElementList[this.ElementList.length - 1].loanType !== '' && Accounting.unformat(this.ElementList[this.ElementList.length - 1].loanBalance) > 0) {
                    this.ShowError = false;
                }
            },
            onLoanTypeChange(index, value) {
                const textbox = document.getElementById(`loanBalance${index}`);
                textbox.focus();
                textbox.select();
                setTimeout(() => {
                    textbox.focus();
                }, 50);
                if (value !== '') {
                    this.changeSelect(value);
                }
            },
            onLoanBalanceChange(value) {
                if (value !== '') {
                    this.changeSelect(value);
                }
            },
            appendIndex(name, index) {
                return name + index;
            },
            destinationURL() {
                this.DestinationLinkOrId += this.totalLoanBalance;
                this.trackButtonClickEvent('debtReliefSimpleCalcStartCTA');
                return this.setDestinationBaseURL(); // in future we can append params to sent
            },
        },
        computed: {
            totalLoanAmount() {
                return this.ElementList.reduce((sum, element) => {
                    if (element.loanBalanceUnformated !== '') return sum + element.loanBalanceUnformated;
                    return sum;
                }, 0);
            },
            totalLoanBalance() {
                if (this.IsCalculateButtonClicked) {
                    return this.ElementList.reduce((sum, element) => {
                        if (element.loanBalanceUnformated !== '') return sum + element.loanBalanceUnformated;
                        return sum;
                    }, 0);
                }
                return 0;
            },
            totalEstimatedReduction() {
                this.destinationURL();
                return this.totalLoanBalance > 7500 ? this.totalLoanBalance > 10000 ? '48' : '24 - 48' : '12 - 24';
            },
            potentialSavingDetails() {
                return this.ElementList.filter(element => element.loanType && element.loanType.trim() !== '' && element.loanBalanceUnformated > 0);
            },
        },
        components: {
            LtLabel,
            NumberInput,
            DropDown,
            Modal,
        },
        mixins: [BaseMixin, Redirection, InteractionTracking, FormatDebtFreeDateFilter, FormatMoneyFilter, Accounting],
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
